<template>
    <div>
        <div class="background-banner" v-if="!plano">
                <h3>Olá {{ nome }}, você ainda não possui um plano</h3>
                <v-btn class="btn-banner" depressed @click="redirecionarPlano">Adquirir Plano</v-btn>
        </div>
        <div class="background-banner"  v-else>
                <h3>Olá {{ nome }}, seu plano: {{ plano }} encontra-se expirado</h3>
                <v-btn class="btn-banner" depressed @click="redirecionarPlano">Renovar Plano</v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BannerPlanoFornecedor',
        props: {
            plano: String
        },
        data() {
            return {
                nome: this.$store.state.loki.user.fullName
            }
        },
        methods: {
            redirecionarPlano() {
                this.$router.push({name: 'planos'})
            },
        }
    }
</script>

<style scoped lang="stylus">

    .background-banner
        background-color #3a6861
        height 70px
        width 100%
        color white
        display flex
        flex-direction row
        align-items center
        padding-left 20px

    .btn-banner
        margin-left 15px
        border-radius 5px
        color #3a6861 !important

</style>